import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { logout } from '../redux/authSlice';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(state => state.auth);
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <Link to="/" className="logo">
          <div className="logo-icon">ВТФ</div>
          <span>v1.1</span>
        </Link>
      </div>

      <nav className="sidebar-nav">
        <Link
          to="/"
          className={`nav-item ${isActive('/') ? 'active' : ''}`}
        >
          <span className="nav-icon">📰</span>
          <span className="nav-label">{t('navbar.feed')}</span>
        </Link>

        <Link
          to="/notifications"
          className={`nav-item ${isActive('/notifications') ? 'active' : ''}`}
        >
          <span className="nav-icon">🔔</span>
          <span className="nav-label">{t('notifications.title')}</span>
        </Link>

        <Link
          to="/messages"
          className={`nav-item ${isActive('/messages') ? 'active' : ''}`}
        >
          <span className="nav-icon">💬</span>
          <span className="nav-label">{t('navbar.messages')}</span>
        </Link>

        {user?.isAdmin && (
          <Link
            to="/admin"
            className={`nav-item ${isActive('/admin') ? 'active' : ''}`}
          >
            <span className="nav-icon">🎛️</span>
            <span className="nav-label">{t('navbar.admin')}</span>
          </Link>
        )}
      </nav>

      <div className="sidebar-search">
        <Link
          to="/search"
          className={`search-link ${isActive('/search') ? 'active' : ''}`}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0.75rem', borderRadius: '8px'}}
        >
          <input
            type="text"
            placeholder={t('admin.search')}
            className="search-input"
            onClick={() => navigate('/search')}
            style={{flex: 1, background: 'transparent', border: 'none', color: 'white', outline: 'none'}}
            readOnly
          />
          <span className="search-icon">🔍</span>
        </Link>
      </div>

      <div className="language-selector" style={{padding: '1rem', borderTop: '1px solid #2a2a2a', display: 'flex', gap: '0.5rem', justifyContent: 'center'}}>
        <button
          onClick={() => changeLanguage('en')}
          style={{
            background: i18n.language === 'en' ? '#1dd1a1' : '#2a2a2a',
            color: i18n.language === 'en' ? 'black' : 'white',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage('ru')}
          style={{
            background: i18n.language === 'ru' ? '#1dd1a1' : '#2a2a2a',
            color: i18n.language === 'ru' ? 'black' : 'white',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          РУ
        </button>
      </div>

      <div className="sidebar-footer">
        <Link
          to={`/profile/${user?._id}`}
          className={`nav-item profile-item ${isActive(`/profile/${user?._id}`) ? 'active' : ''}`}
        >
          <div className="profile-avatar" style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: user?.profilePicture ? 'transparent' : 'linear-gradient(135deg, #1dd1a1, #00b894)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '1rem',
            overflow: 'hidden'
          }}>
            {user?.profilePicture ? (
              <img src={`http://localhost:5000${user.profilePicture}`} alt="Avatar" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
            ) : (
              `${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}`
            )}
          </div>
          <div className="profile-info">
            <div className="profile-name">{user?.firstName} {user?.lastName}</div>
            <div className="profile-username">@{user?.username}</div>
          </div>
        </Link>

        <button className="logout-btn" onClick={handleLogout}>
          👋
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
